import React, { useState } from 'react'
import {
  makeStyles, InputLabel, Select, MenuItem,
} from '@material-ui/core'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
// import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import { DatePicker } from '@material-ui/pickers'
import moment from 'moment'
import Button from '@material-ui/core/Button'
import FormHelperText from '@material-ui/core/FormHelperText'
import InputAdornment from '@material-ui/core/InputAdornment'
// import InputLabel from '@material-ui/core/InputLabel'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import { useDispatch, useSelector } from 'react-redux'
// import OutlinedInput from '@material-ui/core/OutlinedInput'
import { Percent as PercentIcon } from 'react-feather'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import { useParams, useLocation, useNavigate } from 'react-router-dom'
import {
  withStyles,
} from '@material-ui/core/styles'

import { getUsers } from 'src/app/slices/usersSlice'
import { useFormInput } from '../../hooks/useFormInput'
import { useOneTime } from '../../hooks/useOneTime'
import { editDiscount, getDiscountGroup } from '../../app/slices/discountSlice'
import { CssTextField } from '../../utils/CustomInputs'

const CssDatePicker = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'orange',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'orange',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '30px',
      '&.Mui-focused fieldset': {
        borderColor: 'orange',
      },
    },
  },
})(DatePicker)

const CssSelect = withStyles({
  root: {
    '& MuiSelect.Mui-focused': {
      color: 'orange',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'orange',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '30px',
      '&.Mui-focused fieldset': {
        borderColor: 'orange',
      },
    },
  },
})(FormControl)

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: 'orange',
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem)

const useStyle = makeStyles(() => ({
  root: {
    // overflow: 'auto',
  },
  inputs: {
    width: '100%',
  },
  datePicker: {
    '& .MuiPickersDatePickerRoot-toolbar': {
      backgroundColor: 'orange !important',
    },
  },
}))

const entityTypes = [
  { num: 1, name: 'کاربر' },
  { num: 2, name: 'نظر بلبط' },
  { num: 3, name: 'بورسیه' },
  { num: 4, name: 'دوره' },
  { num: 5, name: 'بسته ازمون' },
  { num: 6, name: 'گواهینامه' },
  { num: 7, name: 'گروه دوره سبد خرید' },
  { num: 8, name: 'ویدیو' },
  { num: 9, name: 'معلم' },
]

const DiscountEdit = () => {
  const selectedDiscount = useLocation().state || {}
  const params = useParams()
  const classes = useStyle()
  const [expiredDate, handleDateChange] = useState(moment(selectedDiscount?.expiredDate))
  const discountGroup = useSelector((state) => state.discounts.discountGroup)
  const users = useSelector((state) => state.users.list).filter((user) => user?.role?.roleId === 9)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  console.log('selectedDiscount', selectedDiscount)

  // const discount = useFormInput(selectedDiscount?.discount)
  const maxUsedCount = useFormInput(selectedDiscount?.maxUsedCount)
  const discountPercent = useFormInput(selectedDiscount?.discountPercent)
  const code = useFormInput(selectedDiscount?.code)
  const group = useFormInput(selectedDiscount?.group?.id)
  const assignedTo = useFormInput(selectedDiscount?.assignedTo?.userId)
  const packageNumber = useFormInput(selectedDiscount?.entityType)
  const maxDiscount = useFormInput(selectedDiscount?.maxDiscountPrice)
  const [isActive, setIsActive] = useState(selectedDiscount?.isActive)
  const loggedInUser = useSelector((state) => state.user)
  const roles = useSelector((state) => {
    if (loggedInUser.role.roleId === 5) {
      return state.common.roles.filter((role) => role.roleId === 6)
    } if (loggedInUser.role.roleId === 3) {
      return state.common.roles.filter(
        (role) => (
          role.roleId !== 2 && role.roleId !== 1 && role.roleId !== 8 && role.roleId !== 3
        ),
      )
    } if (loggedInUser.role.roleId === 2) {
      return state.common.roles.filter((role) => role.roleId !== 1)
    }
    return []
  })
  const [currentRole] = useState(roles.map((role) => role.roleId))
  const [searchTerm] = useState(null)

  useOneTime(() => {
    if (!selectedDiscount) navigate('../..')
  })

  React.useEffect(() => {
    dispatch(getDiscountGroup())
    dispatch(getUsers({
      roleIds: currentRole.length ? currentRole : roles.map((role) => role.roleId),
      full: true,
      first: 100000,
      userName: searchTerm,
    }))
  }, [])

  const handleSubmit = (event) => {
    event.preventDefault()
    const model = {
      code: code.value,
      group: discountGroup?.find((g) => g?.id === group.value),
      assignedTo: users?.find((u) => u?.userId === assignedTo.value),
      maxUsedCount: parseInt(maxUsedCount.value, 10),
      discountPercent: parseInt(discountPercent.value, 10),
      expiredDate: expiredDate.toISOString(),
      EntityType: parseInt(packageNumber.value, 10),
      MaxDiscountPrice: parseInt(maxDiscount.value, 10),
      isActive,
    }
    console.log(model)
    dispatch(editDiscount({
      ids: [parseInt(params.discountId, 10)],
      model,
    }))
  }

  return (
    <form onSubmit={handleSubmit}>
      <Card className={classes.root}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography>{selectedDiscount?.name || '--'}</Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={8}>

              <CssTextField
                {...code}
                fullWidth
                required
                variant="outlined"
                label="کد تخفیف"
                type="text"
                disabled
                InputProps={{
                  style: { border: '1px solid red !important' },
                  classes: { input: classes.myInput, focused: classes.focusInput },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} lg={4}>
              <CssSelect variant="outlined" fullWidth className={classes.formControl}>
                <InputLabel id="roleLable">گروه</InputLabel>
                <Select
                  {...group}
                  labelId="roleLable"
                  fullWidth
                  label="گروه"
                  MenuProps={{ classes: { root: classes.listRoot, paper: classes.list } }}
                  InputProps={{
                  }}
                  // defaultValue={selectedDiscount?.group}
                  // value={selectedDiscount?.group}
                >
                  {discountGroup?.map((gr) => (
                    <StyledMenuItem
                      value={gr?.id}
                      className={classes.selectRol}
                      classes={{ root: classes.menuItem }}
                    >
                      {gr?.name}
                    </StyledMenuItem>
                  ))}
                </Select>
              </CssSelect>
            </Grid>

            <Grid item xs={12} sm={12} lg={4}>
              <CssSelect variant="outlined" fullWidth className={classes.formControl}>
                <InputLabel id="roleLable">فروشنده</InputLabel>
                <Select
                  {...assignedTo}
                  labelId="roleLable"
                  fullWidth
                  label="فروشنده"
                  MenuProps={{ classes: { root: classes.listRoot, paper: classes.list } }}
                  InputProps={{
                  }}
                >
                  {users?.map((user) => (
                    <StyledMenuItem
                      value={user?.userId}
                      className={classes.selectRol}
                      classes={{ root: classes.menuItem }}
                    >
                      {user?.userName}
                    </StyledMenuItem>
                  ))}
                </Select>
              </CssSelect>
            </Grid>
            {/* <Grid item xs={12} sm={12} md={6} lg={4}>
              <FormControl required size="small" variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-adornment-amount">درصد تخفیف</InputLabel>
                <OutlinedInput
                  {...discountPercent}
                  label="تعداد مجاز استفاده"
                  id="outlined-adornment-amount"
                  endAdornment={<InputAdornment position="end">
                  <PercentIcon size="18px" color="#00000040" /></InputAdornment>}
                  aria-describedby="standard-weight-helper-text"
                  type="number"
                  inputProps={{
                    'aria-label': 'weight',
                  }}
                />
                <FormHelperText id="standard-weight-helper-text">
                به صورت عدد مثل: ۲۰</FormHelperText>
              </FormControl>
            </Grid> */}

            <Grid item xs={12} sm={12} md={6} lg={4}>
              <FormControl required size="small" variant="outlined" fullWidth>

                <CssTextField
                  {...discountPercent}
                  fullWidth
                  required
                  disabled
                  endAdornment={(
                    <InputAdornment
                      position="end"
                    >
                      <PercentIcon size="18px" color="#00000040" />
                    </InputAdornment>
)}
                  aria-describedby="standard-weight-helper-text"
                  variant="outlined"
                // disabled={!!userId}
                  id="outlined-adornment-amount"
                  label="درصد تخفیف"
                  type="number"
                  InputProps={{
                    style: { border: '1px solid red !important' },
                    classes: { input: classes.myInput, focused: classes.focusInput },
                  }}
                />
                <FormHelperText id="standard-weight-helper-text">به صورت عدد مثل: ۲۰</FormHelperText>
              </FormControl>

            </Grid>

            <Grid item xs={12} sm={12} lg={4}>
              <CssTextField
                {...maxUsedCount}
                fullWidth
                required
                label="تعداد مجاز استفاده"
                type="number"
                // size="small"
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={12} lg={4}>
              <CssDatePicker
                required
                inputVariant="outlined"
                // size="small"
                label="تاریخ انقضا"
                fullWidth
                clearable
                okLabel="تأیید"
                cancelLabel="لغو"
                clearLabel="پاک کردن"
                labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
                value={expiredDate}
                onChange={handleDateChange}
                DialogProps={{ className: classes.datePicker }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={4}>
              <FormControl required size="small" variant="outlined" fullWidth>
                <CssTextField
                  {...maxDiscount}
                  id="outlined-adornment-amount"
                  endAdornment={(
                    <InputAdornment
                      position="end"
                    >
                      <PercentIcon size="18px" color="#00000040" />
                    </InputAdornment>
)}
                  aria-describedby="standard-weight-helper-text"
                  type="number"
                  fullWidth
                  disabled
                  variant="outlined"
                  // label="حداکثر تخفیف قابل اعمال برای این کد تخفیف"
                  label="حداکثر تخفیف قابل اعمال (به تومان)"
                  InputProps={{
                    style: { border: '1px solid red !important' },
                    classes: { input: classes.myInput, focused: classes.focusInput },
                  }}
                />
                {/* <FormHelperText id="standard-weight-helper-text">
                به صورت عدد مثل: ۲۰ هزار تومن</FormHelperText> */}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} lg={4}>
              <CssSelect variant="outlined" fullWidth className={classes.formControl}>
                <InputLabel id="roleLable">نوع کد تخفیف</InputLabel>
                <Select
                  {...packageNumber}
                  labelId="roleLable"
                  fullWidth
                  type="number"
                  label="نوع کد تخفیف"
                  disabled
                  MenuProps={{ classes: { paper: classes.list } }}
                  InputProps={{
                  }}
                >
                  {entityTypes?.map((age) => (
                    <StyledMenuItem
                      value={age?.num}
                      className={classes.selectRol}
                      classes={{ root: classes.menuItem }}
                    >
                      {age?.name}
                    </StyledMenuItem>
                  ))}
                </Select>
              </CssSelect>
            </Grid>
            <Grid item xs={12} sm={12} lg={4}>
              <FormControlLabel
                control={(
                  <Switch
                    checked={isActive}
                    onChange={((event) => setIsActive(event.target.checked))}
                    color="primary"
                  />
        )}
                label={isActive ? 'فعال' : 'غیر فعال'}
              />
            </Grid>
            <Grid container item justify="flex-end" xs={12}>
              <Button type="submit" variant="contained" color="primary">اصلاح کد تخفیف</Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </form>
  )
}

export default DiscountEdit
